import { HrmCodeAllowDeductDto, defaultHrmCodeAllowDeductDto } from "src/dtos/hrmCodeAllowDeduct/hrmCodeAllowDeductDto";

/** 엔티티 필드에 조회 전용 구분명·과세구분명을 더한 그리드 행 데이터이다. 지급·공제 그리드가 함께 쓴다. */
export interface HRM3110_R01Dto extends HrmCodeAllowDeductDto {
    allowDeductTypeNm: string; // AD_TYPE 공통코드의 구분명 (저장하지 않음)
    taxTypeNm: string; // TAX_TYPE 공통코드의 과세구분명 (저장하지 않음)
}

/** 신규 행 생성과 서버 응답의 누락된 화면 필드를 채울 기본값이다. */
export const defaultHRM3110_R01Dto: HRM3110_R01Dto = {
    ...defaultHrmCodeAllowDeductDto,
    allowDeductTypeNm: '',
    taxTypeNm: '',
};
